import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { addJustAddPayForOther } from 'services/easyPay'

export default function useSetJustAddPay(refetch: () => void) {
    const navigate = useNavigate()
    const { mutate } = useMutation({
        mutationFn: (payload: IPayloadForJustAdd) => {
            return addJustAddPayForOther(payload)
        },
        onSuccess: (result, variables) => {
            toast.success('پرداخت با موفقیت انجام شد')
            refetch()
            navigate(-1)
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { mutate }
}
